(function(){
  /* Carousel */
  var track=document.getElementById('jvCarouselTrack');
  var thumbs=document.querySelectorAll('#jv-lander .jv-carousel-thumb');
  var cur=0,cnt=track.children.length;

  function goTo(i){
    cur=i;
    track.children[i].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
    thumbs.forEach(function(t,x){t.classList.toggle('jv-active',x===i)});
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){goTo(+this.dataset.slide)})});

  var prevBtn=document.getElementById('jvCarouselPrev');
  var nextBtn=document.getElementById('jvCarouselNext');
  if(prevBtn) prevBtn.addEventListener('click',function(){goTo((cur-1+cnt)%cnt)});
  if(nextBtn) nextBtn.addEventListener('click',function(){goTo((cur+1)%cnt)});

  var st;
  track.addEventListener('scroll',function(){
    clearTimeout(st);
    st=setTimeout(function(){
      var i=Math.round(track.scrollLeft/track.offsetWidth);
      if(i!==cur&&i>=0&&i<cnt){
        cur=i;
        thumbs.forEach(function(t,x){t.classList.toggle('jv-active',x===i)});
      }
    },80);
  },{passive:true});

  /* Single offer - no tier selection */
  var variantId=43533787103310;
  var sellingPlan=2655420494;
  var qty=1;
  var shakerVariantId=41679873769550;
  var mixerVariantId=42933942616142;
  var discountCode='LTO-CREATINESTICK';
  var giftDiscountCode='FREESTARTERKIT';
  var ctaDefault='Try Jive Today!';

  /* Loading messages for ATC */
  var loadingSteps=[
    'Checking availability',
    'Reserving your order',
    'Applying discount',
    'Redirecting to checkout'
  ];

  function runLoadingSequence(btns,stickyTextEl){
    var stepIndex=0;
    var currentInterval=null;
    var spans=[];
    btns.forEach(function(b){
      var sp=b.querySelector('span');
      if(sp) spans.push(sp);
    });
    if(stickyTextEl) spans.push(stickyTextEl);

    function showStep(){
      if(stepIndex>=loadingSteps.length){
        if(currentInterval) clearInterval(currentInterval);
        if(onDone) onDone();
        return;
      }
      var msg=loadingSteps[stepIndex];
      if(currentInterval) clearInterval(currentInterval);
      var dots=0;
      currentInterval=setInterval(function(){
        dots=(dots%3)+1;
        var txt=msg+Array(dots+1).join('.');
        spans.forEach(function(sp){sp.textContent=txt});
      },400);
      spans.forEach(function(sp){sp.textContent=msg+'.'});
    }

    showStep();
    return {
      next:function(){
        stepIndex++;
        showStep();
      },
      finish:function(){
        if(currentInterval) clearInterval(currentInterval);
      }
    };
  }

  /* ATC - clear cart, add with selling plan, redirect to checkout */
  window.jvHandleAddToCart=function(){
    var btns=document.querySelectorAll('#jv-lander .jv-btn-cta');
    var stickyText=document.getElementById('jvCtaStickyText');
    btns.forEach(function(b){b.style.opacity='.85';b.style.pointerEvents='none'});
    if(stickyText) stickyText.style.pointerEvents='none';

    var seq=runLoadingSequence(btns,stickyText);

    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
    .then(function(){
      seq.next();
      return fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[
          {id:variantId,quantity:qty,selling_plan:sellingPlan}
        ]})
      });
    })
    .then(function(r){if(!r.ok)throw new Error('Cart error');return r.json()})
    .then(function(){
      return fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[
          {id:shakerVariantId,quantity:1},
          {id:mixerVariantId,quantity:1}
        ]})
      }).catch(function(){});
    })
    .then(function(){
      seq.next();
      return new Promise(function(resolve){setTimeout(resolve,800)});
    })
    .then(function(){
      seq.next();
      return new Promise(function(resolve){setTimeout(resolve,600)});
    })
    .then(function(){
      seq.finish();
      return fetch('/discount/'+giftDiscountCode,{method:'GET'});
    })
    .then(function(){
      window.location.href='/checkout?discount='+discountCode;
    })
    .catch(function(e){
      console.error(e);
      seq.finish();
      btns.forEach(function(b){
        b.style.opacity='';b.style.pointerEvents='';
        var sp=b.querySelector('span');
        if(sp) sp.textContent=ctaDefault;
      });
    });
  };

  /* Header - hamburger toggle + smooth scroll nav + shadow + active link */
  var header=document.getElementById('jvHeader');
  var hamburger=document.getElementById('jvHamburger');
  var headerNav=document.getElementById('jvHeaderNav');
  var navLinks=document.querySelectorAll('#jv-lander .jv-header-link');
  var navSections=[];

  hamburger.addEventListener('click',function(){
    hamburger.classList.toggle('jv-open');
    headerNav.classList.toggle('jv-nav-open');
  });

  navLinks.forEach(function(link){
    var id=link.getAttribute('href').replace('#','');
    var el=document.getElementById(id);
    if(el) navSections.push({link:link,el:el});
    link.addEventListener('click',function(e){
      e.preventDefault();
      hamburger.classList.remove('jv-open');
      headerNav.classList.remove('jv-nav-open');
      var target=document.getElementById(id);
      if(target){
        var offset=header?header.offsetHeight:0;
        var top=target.getBoundingClientRect().top+window.pageYOffset-offset;
        window.scrollTo({top:top,behavior:'smooth'});
      }
    });
  });

  /* Sticky */
  var bar=document.getElementById('jvStickyBar'),info=document.querySelector('#jv-lander .jv-product-info');
  function onScroll(){
    bar.classList.toggle('jv-visible',info.getBoundingClientRect().bottom<0);
    if(header) header.classList.toggle('jv-header-shadow',window.scrollY>10);
    /* active nav link */
    var headerH=header?header.offsetHeight:0;
    var active=null;
    for(var i=0;i<navSections.length;i++){
      if(navSections[i].el.getBoundingClientRect().top<=headerH+40) active=navSections[i].link;
    }
    navLinks.forEach(function(l){l.classList.remove('jv-active-link')});
    if(active) active.classList.add('jv-active-link');
  }
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();

  /* Detail panels accordion (product info dropdowns) */
  document.querySelectorAll('#jv-lander .jv-detail-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=this.parentElement;
      var wasOpen=item.classList.contains('jv-open');
      document.querySelectorAll('#jv-lander .jv-detail-item.jv-open').forEach(function(i){i.classList.remove('jv-open')});
      if(!wasOpen) item.classList.add('jv-open');
    });
  });

  /* FAQ accordion */
  document.querySelectorAll('#jv-lander .jv-faq-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=this.parentElement;
      var wasOpen=item.classList.contains('jv-open');
      document.querySelectorAll('#jv-lander .jv-faq-item.jv-open').forEach(function(i){i.classList.remove('jv-open')});
      if(!wasOpen) item.classList.add('jv-open');
    });
  });

  /* Rolling ship widget - ships the next calendar day, any order time.
     Dates resolved in America/New_York; rolls over at local midnight. */
  (function(){
    var pastEl=document.getElementById('jvBatchPast');
    var nowEl=document.getElementById('jvBatchNow');
    var nextEl=document.getElementById('jvBatchNext');
    if(!nowEl) return;
    var DAY_MS=86400000;

    function etParts(ts){
      var dtf=new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',hour12:false,
        year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'});
      var o={};
      dtf.formatToParts(new Date(ts)).forEach(function(p){o[p.type]=p.value});
      if(o.hour==='24') o.hour='00';
      return o;
    }
    /* ms to add to a UTC instant to get ET wall-clock. */
    function etOffset(ts){
      var p=etParts(ts);
      return Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second)-ts;
    }
    /* Absolute timestamp for a given ET wall-clock date/time. */
    function etWall(y,m,d,hh,mm,ss){
      var guess=Date.UTC(y,m-1,d,hh,mm,ss);
      return guess-etOffset(guess);
    }
    function shiftDay(y,m,d,n){
      var t=new Date(Date.UTC(y,m-1,d)+n*DAY_MS);
      return {y:t.getUTCFullYear(),m:t.getUTCMonth()+1,d:t.getUTCDate()};
    }
    function fmtDate(day){
      return new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',
        weekday:'short',month:'short',day:'numeric'}).format(new Date(etWall(day.y,day.m,day.d,12,0,0)));
    }
    function tick(){
      var now=Date.now();
      var p=etParts(now),y=+p.year,m=+p.month,d=+p.day;
      var tomorrow=shiftDay(y,m,d,1);   /* ship date - always next day */
      var past=shiftDay(y,m,d,-30);     /* prior batch, already shipped */
      var next=shiftDay(y,m,d,10);      /* upcoming batch */
      if(pastEl) pastEl.textContent=fmtDate(past);
      if(nowEl) nowEl.textContent=fmtDate(tomorrow);
      if(nextEl) nextEl.textContent=fmtDate(next);
    }
    tick();
    setInterval(tick,60000); /* refresh past midnight ET rollover */
  })();

  /* Lucide */
  if(window.lucide){lucide.createIcons();}
})();
